import { UserNav } from "./UserNav";

export function SidebarFooter() {
  return (
    <div className="p-4">
      <UserNav />
    </div>
  );
}
